import React, { useContext } from 'react'
import modalContext from '../context/ModalContext'
import { makeAuthenticatedGETRequest } from '../utils/endPointCalling';
import { useCookies } from 'react-cookie';
import { Link, useNavigate } from 'react-router-dom';

function ProfileModal() {
    const {profileDetails, setProfileDetails, modal, setModal} = useContext(modalContext);
    const [cookie, setCookie] = useCookies(['token']);
    const navigate = useNavigate();

  return (
    <div onClick={(e)=>{
        setModal(false);
    }} className='w-full h-[100%] bg-black flex justify-center items-center text-black bg-opacity-80 absolute'>
        <div style={{backgroundColor: '#F8F8FF'}} className='w-[30vmax] h-[30vmax] rounded-[0.5vmax] flex flex-col justify-center items-center text-[1.5vmax] gap-[1vmax] font-semibold'>
            <div>Name: {profileDetails.name}</div>
            <div>Email: {profileDetails.email}</div>
            <div>Gender: {profileDetails.gender}</div>
            <div>Contact: {profileDetails.phoneNumber}</div>
            <div>Department: {profileDetails.department}</div>
            <Link to='/delete'><button style={{backgroundColor: '#462054'}} className='text-white text-[1.1vmax] p-[0.5vmax] rounded-[0.5vmax]'>Delete Account</button></Link>
        </div>
    </div>
  )
}

export default ProfileModal